import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { e2eMode } from './e2eMode';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MockInterceptor, RecorderInterceptor } from 'mock-recorder-interceptor';
import { StateReplaceProvider } from '@uxdf/direct-shared-lib';
import { Router } from '@angular/router';

/* eslint-disable */
export function onAppInitRouterNavigationEvents(injector: Injector) {
  return () => {
    const router = injector.get(Router);

    window.addEventListener('routerNavigate', (e: any) => {
      const { url, queryParams } = e.detail;
      router.navigate(url, {
        queryParams
      });
    });
  };
}

@NgModule({
  providers: [
    { provide: 'e2eMode', useValue: e2eMode },
    ...(e2eMode.e2e
      ? [
          {
            provide: HTTP_INTERCEPTORS,
            useClass: e2eMode.apiRecording ? RecorderInterceptor : MockInterceptor,
            multi: true
          },
          StateReplaceProvider
        ]
      : []),
    {
      provide: APP_INITIALIZER,
      useFactory: onAppInitRouterNavigationEvents,
      multi: true,
      deps: [Injector]
    }
  ]
})
export class E2EModule {}
